import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MDBView } from "mdbreact";
import { Search } from "../../../../../components/searchables";
import {
  BROWSE,
  SetFILTERED,
} from "../../../../../services/redux/slices/diagnostics/cases";

export default function Header({ onAdd }) {
  const dispatch = useDispatch();
  const { token } = useSelector(({ auth }) => auth);
  const { collections } = useSelector(({ cases }) => cases);

  useEffect(() => {
    if (token) {
      dispatch(BROWSE({ token }));
    }
  }, [token, dispatch]);

  return (
    <MDBView
      cascade
      className="gradient-card-header blue-gradient py-3 px-4 mb-3"
      style={{ borderRadius: "0.3rem" }}
    >
      <div className="d-flex justify-content-between align-items-center flex-wrap">
        <h5 className="white-text m-0">
          {collections?.length || 0} Patient Cases
        </h5>

        <div
          className="d-flex align-items-center gap-2 mt-2 mt-md-0"
          style={{ minWidth: "300px" }}
        >
          <Search
            collections={collections}
            placeholder="Search patient cases..."
            setFiltered={(items) => dispatch(SetFILTERED(items))}
            handleAdd={() => onAdd?.()}
            reset={() => dispatch(SetFILTERED(collections))}
            hideButton={true}
          />
        </div>
      </div>
    </MDBView>
  );
}
